import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";

export const fetchShowPublishment = createAsyncThunk(
  "publishments/showPublishment",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`/publishments/${id}`);
      console.log(response.data.data);
      return response.data.data;
    } catch (error) {
      console.error("API Error:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const showPublishmentSlice = createSlice({
  name: "showPublishment",
  initialState: {
    loading: false,
    error: null,
    publishment: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchShowPublishment.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.publishment = null; // Reset publishment on new fetch
      })
      .addCase(fetchShowPublishment.fulfilled, (state, action) => {
        state.loading = false;
        state.publishment = action.payload || {}; // Prevent null state
      })
      .addCase(fetchShowPublishment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default showPublishmentSlice.reducer;
